<div
  class="tag {{ severity }} size-{{ size }} white-space-nowrap {{ align }} {{
    styleClass.join(', ')
  }}"
  pTooltip="{{ title }}"
  [showDelay]="150"
  [hideDelay]="150"
  appendTo="body"
  tooltipPosition="top"
  tooltipStyleClass="hover"
  [ngClass]="{
    'no-icon': !icon && !primeIcon,
    square: square,
    outlined: outlined,
    dotted: dotted,
    small: small,
    'icon-only': iconOnly,
    'no-min-width': noMinWidth,
    interactive: interactive,
  }">
  @if (icon) {
    <svg class="icon">
      <use [attr.xlink:href]="'#' + icon" />
    </svg>
  }
  @if (primeIcon) {
    <i class="pi" [ngClass]="primeIcon"></i>
  }
  <ng-content></ng-content>
</div>
